import { forwardRef, Grid, Image, Text } from '@chakra-ui/react'
import type { GridProps } from '@chakra-ui/styled-system'

import type { Document } from '../../data/documents'
import documentIconBlue from '../../images/document-icon-blue.svg'
import documentIconGray from '../../images/document-icon-gray.svg'
import documentIconGreen from '../../images/document-icon-green.svg'
import documentIconOrange from '../../images/document-icon-orange.svg'
import documentIconRed from '../../images/document-icon-red.svg'

export interface DocumentIconProps extends GridProps {
  documentType: string
  iconColor?: 'gray' | 'green' | 'blue' | 'red' | 'orange'
}

export const documentTypeColorMap: Record<Document['documentType'], DocumentIconProps['iconColor']> = {
  ps: 'blue',
  doc: 'blue',
  zk: 'green',
  xlsx: 'green',
  zzj: 'gray',
  ipid: 'gray',
  vpp: 'gray',
  pdf: 'red',
  other: 'red',
  pptx: 'orange',
}

export const DocumentIcon = forwardRef(
  ({ documentType, ...rest }: DocumentIconProps, ref) => {
    const iconColor = documentTypeColorMap[documentType as Document['documentType']]
    let iconLabelColor
    let iconLabel
    let iconFile

    switch (iconColor) {
      case 'blue':
        iconFile = documentIconBlue
        iconLabelColor = 'white'
        break
      case 'green':
        iconFile = documentIconGreen
        iconLabelColor = 'green.500'
        break
      case 'red':
        iconFile = documentIconRed
        iconLabelColor = 'white'
        break
      case 'orange':
        iconFile = documentIconOrange
        iconLabelColor = 'white'
        break
      case 'gray':
      default:
        iconFile = documentIconGray
        iconLabelColor = '#728492'
        break
    }

    switch (documentType) {
      case 'ps':
        iconLabel = 'PS'
        break
      case 'zk':
        iconLabel = 'ZK'
        break
      case 'zzj':
        iconLabel = 'ZzJ'
        break
      case 'ipid':
        iconLabel = 'IPID'
        break
      case 'vpp':
        iconLabel = 'VPP'
        break
      case 'doc':
        iconLabel = 'DOC'
        break
      case 'pdf':
        iconLabel = 'PDF'
        break
      default:
        iconLabel = documentType.toUpperCase()
        break
    }

    return (
      <Grid
        ref={ref}
        sx={{
          w: {
            base: '32px',
            md: '44px',
          },
          minW: {
            base: '32px',
            md: '44px',
          },
          h: {
            base: '34px',
            md: '50px',
          },
          minH: {
            base: '34px',
            md: '50px',
          },
          position: 'relative',
        }}
        {...rest}
      >
        <Image
          src={iconFile}
          alt=""
          sx={{
            w: {
              base: '32px',
              md: '44px',
            },
            h: {
              base: '34px',
              md: '50px',
            },
          }}
        />

        <Text
          sx={{
            position: 'absolute',
            top: '55%',
            left: '50%',
            color: iconLabelColor,
            fontWeight: 'bold',
            transform: 'translate(-50%, -50%)',
          }}
        >
          {iconLabel}
        </Text>
      </Grid>
    )
  },
)

